import i18n from "../../../../utils/i18n";
import classes from "./searchFlowProgressBar.module.scss";

const SearchFlowProgressBar = ({ value = 0 }) => {
  const clamped = Math.min(1, Math.max(0, value));
  const percent = Math.round(clamped * 100);

  return (
    <div
      className={classes.track}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={percent}
      aria-label={i18n.t("searchflow.progressbararia")}
    >
      <div className={classes.fill} style={{ width: `${percent}%` }} />
    </div>
  );
};

export default SearchFlowProgressBar;
